import { render, staticRenderFns } from "./ListBrand.vue?vue&type=template&id=3ed9c62e&"
import script from "./ListBrand.vue?vue&type=script&lang=js&"
export * from "./ListBrand.vue?vue&type=script&lang=js&"
import style0 from "./ListBrand.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports